import React, { useState } from "react";
import Image from "next/image";

export default function Team_Home_Layout4({ data }: { data: any }) {
  const [selectedFounder, setSelectedFounder] = useState(0);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl   text-center mb-12">{data.title}</h2>
        <div className="flex flex-col md:flex-row gap-8">
          <div className="md:w-1/3 space-y-4">
            {data.founders.map((founder: any, index: number) => (
              <button
                key={founder.id}
                className={`w-full flex items-center space-x-4 p-4 rounded-lg transition-all ${
                  selectedFounder === index ? 'bg-[#F9F7F3] shadow-md' : 'hover:bg-gray-50'
                }`}
                onClick={() => setSelectedFounder(index)}
              >
                <div className="w-12 h-12 relative rounded-full overflow-hidden">
                  <Image
                    src={founder.picture.data.attributes.url}
                    alt={founder.name}
                    fill
                    className="object-cover"
                  />
                </div>
                <div className="text-left">
                  <h3 className=" ">{founder.name}</h3>
                  <p className="text-sm text-[#5A534A]">{founder.designation}</p>
                </div>
              </button>
            ))}
          </div>
          <div className="md:w-2/3 bg-[#F9F7F3] rounded-lg p-8">
            {data.founders[selectedFounder] && (
              <>
                <div className="flex items-center space-x-6 mb-6">
                  <div className="w-24 h-24 relative rounded-full overflow-hidden">
                    <Image
                      src={data.founders[selectedFounder].picture.data.attributes.url}
                      alt={data.founders[selectedFounder].name}
                      fill
                      className="object-cover"
                    />
                  </div>
                  <div>
                    <h3 className="text-2xl  ">{data.founders[selectedFounder].name}</h3>
                    <p className="text-[#5A534A]">{data.founders[selectedFounder].designation}</p>
                  </div>
                </div>
                <p className="text-[#5A534A]">{data.founders[selectedFounder].about}</p>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}